import React from 'react'
import { connect } from 'react-redux'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { errorMessage } from 'lib/styleguide/base.scss'
import { experienceGuidePageActions } from 'data/resources/experienceGuidePages'

class DeleteGuidePageDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      deletePending: false,
      deleteError: null
    }
  }

  onConfirm = () => {
    const { guide, onRequestClose, expanded, setExpanded, deleteGuidePage } = this.props

    this.setState({ deletePending: true })
    expanded && setExpanded(null)
    deleteGuidePage(guide)
      .then(() => { onRequestClose() })
      .catch(e => {
        return this.setState({ deletePending: false, deleteError: e.details[0].error_code })
      })
  }

  render () {
    const { guide, onRequestClose } = this.props
    const { deletePending, deleteError } = this.state

    return (
      <ConfirmationDialog
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        confirmText='Yes, Delete this Section'
        onConfirm={this.onConfirm}
        confirmPending={deletePending}
        danger>
        <p>Are you sure you want to delete <strong>{guide.title}</strong>?</p>
        {deleteError && <div className={errorMessage}>
          {deleteError === 'unprocessable_entity' && guide.isHeader
            ? "Oops, you can't delete a header with nested Guide Pages. Please delete any nested pages before deleting this header."
            : 'Oops, we encountered an error while deleting this Guide Page. Please try again.'}
        </div>}
      </ConfirmationDialog>
    )
  }
}

const mapDispatchToProps = {
  deleteGuidePage: experienceGuidePageActions.delete
}

export const DeleteGuidePageDialogContainer = connect(
  null,
  mapDispatchToProps
)(DeleteGuidePageDialog)
